import script from "./BaseLatexElement.vue?vue&type=script&lang=ts&setup=true"
export * from "./BaseLatexElement.vue?vue&type=script&lang=ts&setup=true"

import "./BaseLatexElement.vue?vue&type=style&index=0&id=1587280d&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1587280d"]])

export default __exports__